import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["use"];
import styled from 'styled-components';
import { FullstoryAPI } from 'data-ops-fullstory';
import { generatePath, useHistory, useRouteMatch } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIllustration from 'UIComponents/image/UIIllustration';
import Small from 'UIComponents/elements/Small';
import UIButton from 'UIComponents/button/UIButton';
import { useIsUngated } from 'automation-ui-core/hooks/authHooks';
import { AI_GENERATED_WORKFLOWS } from 'automation-ui-enrollment/constants/Gates';
import Routes from 'automation-ui-enrollment/constants/Routes';
import UIBadge from 'UIComponents/badge/UIBadge';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { filterProps } from 'foundations-components/utils/filterProps';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TriggersAIAssistantButtonContainer = styled.div.withConfig({
  displayName: "TriggersAIAssistantButton__TriggersAIAssistantButtonContainer",
  componentId: "cph8u1-0"
})(({
  theme: _theme,
  $cssStyles
}) => {
  const theme = _theme;
  return Object.assign({
    display: 'flex',
    alignItems: 'center',
    padding: `${theme.space['600']} ${theme.space['800']}`,
    borderBottom: `1px solid ${theme.color['border-primary-subtle']}`
  }, $cssStyles);
});
export default function TriggersAIAssistantButton(_ref) {
  let {
      use = 'button'
    } = _ref,
    spaceProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tokenProps
  } = filterProps(spaceProps);
  const spaceStyles = useMapTokenPropsToCSS(tokenProps);
  const history = useHistory();
  const {
    params: {
      flowId
    }
  } = useRouteMatch();
  const handleClick = () => {
    FullstoryAPI.event('clickedEditWithAiButtonTriggers');
    history.push(generatePath(Routes.AI_ASSISTANT_TRIGGERS, {
      flowId
    }));
  };
  const isUngatedToAITriggers = useIsUngated(AI_GENERATED_WORKFLOWS);
  if (!isUngatedToAITriggers) {
    return null;
  }
  if (use === 'button') {
    return /*#__PURE__*/_jsxs(Flex, Object.assign({
      alignItems: "center"
    }, spaceProps, {
      children: [/*#__PURE__*/_jsx(Button, {
        use: "tertiary-light",
        size: "sm",
        onClick: handleClick,
        marginBlockStart: "0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.enrollSelection.aiAssistantButton.title"
        })
      }), /*#__PURE__*/_jsx(UIBadge, {
        use: "beta",
        className: "m-left-1",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "aiAssistantPanel.body.addTriggersPanel.triggerDescriptionSection.beta"
        })
      })]
    }));
  } else {
    return /*#__PURE__*/_jsxs(TriggersAIAssistantButtonContainer, {
      $cssStyles: spaceStyles,
      children: [/*#__PURE__*/_jsx(UIIllustration, {
        name: "breeze-ai",
        width: 60,
        height: 60
      }), /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        alignItems: "start",
        marginInlineStart: "300",
        children: [/*#__PURE__*/_jsxs(View, {
          marginBlockEnd: "100",
          as: "div",
          children: [/*#__PURE__*/_jsx("strong", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "automation-ui-enrollment.redesign.enrollSelection.aiAssistantButton.title"
            })
          }), /*#__PURE__*/_jsx(UIBadge, {
            use: "beta",
            className: "m-left-1",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "aiAssistantPanel.body.addTriggersPanel.triggerDescriptionSection.beta"
            })
          })]
        }), /*#__PURE__*/_jsx(Small, {
          use: "help",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.redesign.enrollSelection.aiAssistantButton.description"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          use: "tertiary",
          className: "m-top-2",
          size: "sm",
          onClick: handleClick,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.redesign.enrollSelection.aiAssistantButton.actionLabel"
          })
        })]
      })]
    });
  }
}